import React, { ReactElement } from "react";
import {
  PictureCard,
  PictureCardImage,
  PictureCardTitle,
  PictureCardProps,
  ImageRatio,
  ResponsiveSanityImageProps,
  BackgroundColor,
  ResponsiveSanityImage
} from "@silversea-ssc/ui-components-react";

import { isString, titleCase } from "src/utils/strings";
import { CardAction } from "./cardAction";
import { WrapWithLink, actionFromCardAction } from "components/WrapWithLink";
import CardTags from "components/CardTags/CardTags";

export interface LinkPictureCardProps extends PictureCardProps {
  title: string | JSX.Element | undefined;
  imageAltText?: string;
  image?: ResponsiveSanityImageProps["image"];
  background?: BackgroundColor;
  action: CardAction;
  tags?: ReactElement;
}

const LinkPictureCard: React.FC<
  React.PropsWithChildren<LinkPictureCardProps>
> = ({
  title,
  image,
  imageAltText,
  action,
  borderColor,
  trackingName,
  background = "white",
  tags
}) => {
  const titleCaseTitle = isString(title) ? titleCase(title) : title;
  const altText = imageAltText || (isString(title) ? title : undefined);
  const linkTitle = isString(title) ? title : altText;

  return (
    <PictureCard
      borderColor={borderColor}
      trackingName={trackingName}
      background={background}
    >
      <WrapWithLink
        {...actionFromCardAction(action)}
        title={linkTitle}
        data-content-piece="card_button"
        style={{ display: "block" }}
      >
        {tags && <CardTags position="absolute">{tags}</CardTags>}
        {image && (
          <PictureCardImage>
            <ImageRatio ratio="card">
              <ResponsiveSanityImage
                image={image}
                alt={altText}
                draggable={false}
                loading="lazy"
                defaultWidth={400}
                defaultHeight={600}
              />
            </ImageRatio>
          </PictureCardImage>
        )}
        <PictureCardTitle>{titleCaseTitle}</PictureCardTitle>
      </WrapWithLink>
    </PictureCard>
  );
};

export default React.memo(LinkPictureCard);
